module.exports = __webpack_public_path__ + "img/noble3.e777934c.png";